import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import variables from './variables';

const activeCss = css`
  border-bottom-color: ${variables.color.primary} !important;
  color: ${variables.color.primary};

  &:hover {
    background-color: transparent;
  }
`;

const Tab = styled(Link)`
  border-bottom: 2px solid transparent;
  color: #999;
  font-size: 14px;
  margin-bottom: -2px;
  margin-left: 10px;
  padding: 10px 15px 5px;
  transition: all 200ms ease;

  &:hover {
    border-bottom-color: #ddd;
    text-decoration: none !important;
  }

  ${props => props.active && activeCss}
`;

const Tabs = styled('nav')`
  border-bottom: 2px solid #eee;
  display: flex;
  flex-direction: row;
  margin: 0 0 30px;
`;

Tab.propTypes = {
  active: PropTypes.bool,
  to: PropTypes.string.isRequired
};

export { Tab };

export default Tabs;
